"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var shape = prop_types_1.default.shape({
  lines: prop_types_1.default.arrayOf(prop_types_1.default.string).isRequired
});

function create(value) {
  var lines = value.split('\n');
  return {
    lines: lines
  };
}

function insert(buffer, at, value) {
  return replace(buffer, at, at, value);
}

function remove(buffer, from, to) {
  return replace(buffer, from, to, ['']);
}

function replace(buffer, from, to, lines) {
  var bufferLines = lines.map(function (line, index) {
    var prefix = index === 0 ? buffer.lines[from.row].slice(0, from.col) : '';
    var suffix = index === lines.length - 1 ? buffer.lines[to.row].slice(to.col) : '';
    return prefix + line + suffix;
  });
  var newLines = buffer.lines.slice();
  newLines.splice.apply(newLines, __spread([from.row, to.row - from.row + 1], bufferLines));
  return {
    lines: newLines
  };
}

exports.Buffer = {
  create: create,
  insert: insert,
  remove: remove,
  replace: replace,
  shape: shape
};